import { ReactComponent as Instagram } from 'assets/icons/icon-instagram.svg';

export default Instagram;
